// Navbar.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faBars } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/logo.png";

export default function Navbar({ userData, logout }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const userRole = localStorage.getItem("userRole");

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  const handleOutsideClick = (e) => {
    if (!e.target.closest(".nav")) setIsSidebarOpen(false);
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden"; // يمنع تمرير الصفحة
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.body.style.overflow = "auto"; // يرجع التمرير
      document.removeEventListener("click", handleOutsideClick);
    }
    return () => {
      document.body.style.overflow = "auto";
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isSidebarOpen]);

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="head-p">
            <img className="logo" src={logo} alt="Logo" />
            <p>
              <span>مقابر</span>
              <sub>أهالي الشوبك الغربي</sub>
            </p>
          </div>
        </div>
      </header>

      <nav className="nav">
        <div className="container">
          <span className="menu-toggle" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faBars} />
          </span>

          <div className={`links ${isSidebarOpen ? "open" : ""}`}>
            {userData ? (
              <ul onClick={closeSidebar}>
                {userRole === "manager" && (
                  <>
                    <li>
                      <Link to="/" className="toggle active">
                        الرئيسية
                      </Link>
                    </li>
                    <li><Link to="/man">الرجال</Link></li>
                    <li><Link to="/woman">النساء</Link></li>
                    <li><Link to="/bones">العظام</Link></li>
                    <li><Link to="/articles">المقالات</Link></li>
                    <li><Link to="/approved">الاقتراحات</Link></li>
                    <li><Link to="/suggestions">ادارة الاقتراحات</Link></li>
                    <li><Link to="/creategrave">انشاء مقبرة</Link></li>
                    <li><Link to="/showgraves">عرض المقابر</Link></li>
                    <li><Link to="/register">انشاء ادمن</Link></li>
                    <li><Link to="/burialRequestsList">مراجعة طلبات التسجيل</Link></li>
                    <li><Link to="/resetpassword">اعادة تعيين كلمة المرور</Link></li>
                    <li className="cursor-pointer" onClick={logout}>تسجيل الخروج</li>
                  </>
                )}

                {userRole === "admin" && (
                  <>
                    <li><Link to="/" className="toggle active">الرئيسية</Link></li>
                    <li><Link to="/creategrave">انشاء مقبرة</Link></li>
                    <li><Link to="/showgraves">عرض المقابر</Link></li>
                    <li><Link to="/man">الرجال</Link></li>
                    <li><Link to="/woman">النساء</Link></li>
                    <li><Link to="/bones">العظام</Link></li>
                    <li><Link to="/contact">تواصل معنا</Link></li>
                    <li><Link to="/approved">الاقتراحات</Link></li>
                    <li className="cursor-pointer" onClick={logout}>تسجيل الخروج</li>
                  </>
                )}
              </ul>
            ) : (
              <ul onClick={closeSidebar}>
                <li><Link to="/" className="toggle active">الرئيسية</Link></li>
                <li><Link to="/man">الرجال</Link></li>
                <li><Link to="/woman">النساء</Link></li>
                <li><Link to="/bones">العظام</Link></li>
                <li><Link to="/contact">تواصل معنا</Link></li>
                <li><Link to="/approved">الاقتراحات</Link></li>
                <li><Link to="/burialRequestForm">طلب دفن</Link></li>
                <li><Link to="/login">تسجيل الدخول</Link></li>
              </ul>
            )}
          </div>
        </div>
      </nav>
    </>
  );
}
